// 5XX
const isFatal = status => (
    !!status.toString().match(/5(\d{2})/)
)

export const isUnauthorized = error => (
    error.response && error.response.status === 401
)

export const isUnknownError = error => (
    !error || !error.response || (error.response && isFatal(error.response.status))
)

// NOTE: We only store "handled" errors here, which consists of
// 400 Bad Request responses. For 5XX errors, unknown errors are thrown.
export const ERROR_CODES = {
    // Generic errors
    VALIDATION_ERROR: 'validation-error',
    INVALID_SELECTION: 'invalid-selection',
    LIVE_PRICE_UNAVAILABLE: 'live-price-unavailable',
    INVALID_FREE_BET: 'invalid-free-bet',
    BOG_UNAVAILABLE: 'best-odds-guaranteed-unavailable',

    // Bet-specific errors
    BETTING_SUSPENDED: 'betting-suspended',
    PRICE_CHANGED: 'price-changed',
    STAKE_TOO_LOW: 'stake-too-low',
    STAKE_TOO_HIGH: 'stake-too-high',
    STARTING_PRICE_UNAVAILABLE: 'start-price-unavailable',

    // Other errors
    INSUFFICIENT_FUNDS: 'insufficient-funds',
}

// Note that generic error messages live with the globalModal
export const ERROR_MESSAGES = {
    INSUFFICIENT_FUNDS: 'You have insufficient funds',

    // Bet-specific errors
    BETTING_SUSPENDED: 'Betting is suspended on this event',
    PRICE_CHANGED: 'Price has changed from %OLD% to %NEW%',
    PRICE_CHANGED_SP: 'Live odds now available',
    STAKE_TOO_LOW: 'The minimum stake for this bet is %PRICE%',
    STAKE_TOO_HIGH: 'The maximum stake for this bet is %PRICE%',
}

export const isGenericError = (body) => {
    if (!body.errors || body.errors.length === 0) {
        return true
    }

    return body.errors.some(error => error.code === ERROR_CODES.VALIDATION_ERROR
            || error.code === ERROR_CODES.INVALID_SELECTION
            || error.code === ERROR_CODES.LIVE_PRICE_UNAVAILABLE
            || error.code === ERROR_CODES.INVALID_FREE_BET
            || error.code === ERROR_CODES.BOG_UNAVAILABLE)
}

export const isBogUnavailable = (body) => {
    if (!body.errors || body.errors.length === 0) {
        return false
    }

    return body.errors.some(error => error.code === ERROR_CODES.BOG_UNAVAILABLE)
}

// Reorders errors to put suspended errors last - avoids conflict issues
export const getErrorsToFire = (errors) => {
    const nonSuspendedErrors = errors.filter(error => error.code !== ERROR_CODES.BETTING_SUSPENDED)
    const suspendedErrors = errors.filter(error => error.code === ERROR_CODES.BETTING_SUSPENDED)

    return nonSuspendedErrors.concat(suspendedErrors)
}



// WEBPACK FOOTER //
// /src/js/common/utils/apiErrors.js